import Divider from "components/atoms/Divider";
import Link from "next/link";
import Grid from "shared/components/atoms/grid";
import { Image } from "shared/components/atoms/Image";
import { zodiacs } from "shared/models/daily_holoscope";
import { ZodiacSign } from "shared/types";
import tw, { styled } from "twin.macro";
import { Paths } from "utils/routes";

const useStyles = () => {
  return {
    font: tw`font-hira-mincho text-center leading-7`,
  };
};

const ZodiacName = styled.h3`
  color: #3c424a;
  letter-spacing: 0.53px;
`;

const ZodiacPeriod = styled.span`
  font-size: 19px;
  color: #e271b6;
  letter-spacing: 0.56px;
`;

interface Props {
  className?: string;
}

export const ZodiacList = ({ className }: Props) => {
  const classes = useStyles();
  return (
    <div className={className}>
      {Object.keys(zodiacs).map((zodiacSign: ZodiacSign) => (
        <Link key={zodiacSign} href={Paths.dailyHoloscopes.show(zodiacSign)}>
          <a>
            <Grid direction="row" alignItems="center" justify="space-evenly">
              <Image
                src={`/icons/${zodiacSign}.svg`}
                width={85}
                height={85}
                layout="fixed"
              />
              <Grid alignItems="center">
                <ZodiacName tw="font-semibold text-lg" css={classes.font}>
                  {zodiacs[zodiacSign].localized}
                </ZodiacName>
                <ZodiacPeriod tw="font-light" css={classes.font}>
                  {zodiacs[zodiacSign].period}
                </ZodiacPeriod>
              </Grid>
            </Grid>
            <Divider color="#F3F7FD" />
          </a>
        </Link>
      ))}
    </div>
  );
};
